module.exports = __webpack_public_path__ + "img/ve.1cc35956.svg";